import React from 'react';
import s from './TopMenuProfileTop.module.scss';
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-left-white.svg';
import { ReactComponent as ShareIcon } from 'images/new-icons/share-icon.svg';
import { useNavigate } from 'react-router-dom';
import { useSpring } from '@react-spring/web';
import { useActions } from 'store/useActions';
import ShareDrawer from 'modules/feed/components/Feed/ShareDrawer';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useProfileById from 'sdk/hooks/user/useProfileById';

const TopMenuProfileTop = () => {
  const { data: isAuthData } = useIsAuth();
  const { data: userData } = useProfileById(isAuthData?.user?.id || '');
  const navigate = useNavigate();
  const [{ y }, api] = useSpring(() => ({
    y: window.innerHeight,
    config: { tension: 300, friction: 30 },
  }));

  const { setIsShareOpened } = useActions();

  const openDrawer = () => {
    navigator.share({
      title: 'Share',
      text: 'Share',
      url: `${window.location.href}/${userData?.username}`,
    });
  };

  const handleBack = () => navigate(-1);

  return (
    <div className={s.container}>
      <GoBackIcon onClick={handleBack} />
      <div className={s.container_right_icons} onClick={openDrawer}>
        <ShareIcon />
      </div>
      <ShareDrawer
        isOpenShare={true}
        setIsShareOpened={setIsShareOpened}
        openDrawer={openDrawer}
        api={api}
        y={y}
        downloadLink={window.location.href}
      />
    </div>
  );
};

export default TopMenuProfileTop;
